module.exports = __webpack_public_path__ + "img/vessel_own.b136a9ad.svg";